var t={buttonLabel:"rl2_ButtonWithLabel-module_buttonLabel_ONe8z",showLabel:"rl2_ButtonWithLabel-module_showLabel_Q9S1z"};export{t as default};
